import React from "react";
import { isInputHasLocale } from "../../helpers/forms";

const InputError = ({ errors, name, locale = "" }) => {
	if (!isInputHasLocale(locale)) {
		return errors?.[name] ? (
			<p className="error-hint">{errors?.[name].message}</p>
		) : (
			""
		);
	}

	return errors?.[name]?.[locale] ? (
		<p className="error-hint">{errors?.[name]?.[locale].message}</p>
	) : (
		""
	);
};

export default InputError;
